import React, { useState, useEffect, useRef } from 'react';

const NewsTicker = ({ news, interval = 3000, newsPerPage = 2 }) => {
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const tickerRef = useRef(null);

  useEffect(() => {
    const ticker = setInterval(() => {
      // Increment index and wrap around using modulus
      setCurrentNewsIndex(prevIndex => (prevIndex + newsPerPage) % news.length);
    }, interval);

    return () => clearInterval(ticker);
  }, [interval, news.length, newsPerPage]);

  // Calculate total height for the sliding effect
  const itemHeight = 100; // height of each item
  const totalItems = news.length;

  // Calculate translateY based on the current index
  const translateY = -((currentNewsIndex * itemHeight) % (itemHeight * totalItems));

  // Prepare the items for the ticker, ensuring a seamless loop
  const displayedItems = [...news.slice(currentNewsIndex), ...news.slice(0, currentNewsIndex + newsPerPage)];

  return (
    <div className="news-ticker-container" ref={tickerRef}>
      <ul className="news-ticker" style={{ transform: `translateY(${translateY}px)` }}>
        {displayedItems.map((item, index) => (
          <li key={index} className="news-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NewsTicker;
